import React from 'react';
import { ReactComponent as Info } from 'assets/icons/icon-right-title.svg';
import { twMerge } from 'tailwind-merge';

type FieldDescribeProps = {
  children: React.ReactNode;
  className?: string;
};

const FieldDescribe = ({ children, className }: FieldDescribeProps) => {
  return (
    <p
      className={twMerge(
        'text-med-gray-3 font-semibold text-xs flex flex-row items-center gap-0.5',
        className,
      )}
    >
      <Info className="flex-shrink-0 w-4 h-4" />
      <span>{children}</span>
    </p>
  );
};

export default FieldDescribe;
